"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDF_HEADER_SEARCH_WINDOW = void 0;
exports.bytesAreValidPdf = bytesAreValidPdf;
exports.blobIsValidPdf = blobIsValidPdf;
exports.PDF_HEADER_SEARCH_WINDOW = 1024;
const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46, 0x2d];
function bytesAreValidPdf(bytes) {
    const lastStart = Math.min(bytes.length, exports.PDF_HEADER_SEARCH_WINDOW) - PDF_SIGNATURE.length;
    for (let start = 0; start <= lastStart; start++) {
        let matched = true;
        for (let offset = 0; offset < PDF_SIGNATURE.length; offset++) {
            if (bytes[start + offset] !== PDF_SIGNATURE[offset]) {
                matched = false;
                break;
            }
        }
        if (matched) {
            return true;
        }
    }
    return false;
}
async function blobIsValidPdf(blob) {
    const header = await blob.slice(0, exports.PDF_HEADER_SEARCH_WINDOW).arrayBuffer();
    return bytesAreValidPdf(new Uint8Array(header));
}
//# sourceMappingURL=is-valid-pdf.js.map